/**
 * PrivacyConsentCheckbox — the required "I agree to the Privacy Policy" control
 * shown on the account-creation surfaces (Get Started, Request Access, Accept
 * Invitation). The submit button on each of those forms stays disabled until
 * this is checked; the server then records the consent at account creation.
 *
 * The link opens the full policy (`/privacy`) in a new tab so reading it never
 * loses the half-filled form. It's a plain anchor (not a router <Link>) — the
 * new tab does a fresh load of /privacy, and it keeps this control free of a
 * router dependency so it renders anywhere (e.g. auth forms whose tests stub
 * react-router). The policy text itself is served from the single source file
 * on the server — see server/assets/legal/privacy-policy.md.
 */

export default function PrivacyConsentCheckbox({
  checked,
  onChange,
  id = 'privacy-consent',
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  id?: string;
}) {
  return (
    <label htmlFor={id} className="flex items-start gap-2.5 cursor-pointer select-none">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 flex-shrink-0 accent-[#0F766E] cursor-pointer"
      />
      <span className="text-xs text-slate-600 leading-relaxed">
        I have read and agree to Avium's{' '}
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#134E4A] font-semibold underline underline-offset-2 hover:text-[#0F766E]"
        >
          Privacy Policy
        </a>
        , including how Avium hosts and processes my organization's data.
      </span>
    </label>
  );
}
